import React from 'react';

const Logo = ({ width = 28, height = 28, className = "custom-logo-svg" }) => (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <defs>
            <linearGradient id="logoGrad1" x1="0" y1="32" x2="32" y2="0">
                <stop offset="0%" stopColor="#4f46e5" />
                <stop offset="100%" stopColor="#c084fc" />
            </linearGradient>
            <linearGradient id="logoGrad2" x1="0" y1="32" x2="32" y2="0">
                <stop offset="0%" stopColor="#0ea5e9" />
                <stop offset="100%" stopColor="#2dd4bf" />
            </linearGradient>
            <linearGradient id="logoGrad3" x1="0" y1="32" x2="32" y2="0">
                <stop offset="0%" stopColor="#3b82f6" />
                <stop offset="100%" stopColor="#8b5cf6" />
            </linearGradient>
            <linearGradient id="glowBg" x1="0" y1="0" x2="32" y2="32">
                <stop offset="0%" stopColor="#4f46e5" stopOpacity="0.2" />
                <stop offset="100%" stopColor="#0ea5e9" stopOpacity="0.05" />
            </linearGradient>
            <filter id="glowShadow" x="-50%" y="-50%" width="200%" height="200%">
                <feDropShadow dx="0" dy="2" stdDeviation="2" floodColor="#4f46e5" floodOpacity="0.4" />
            </filter>
        </defs>

        {/* Rotating Hexagon Background */}
        <g transform="translate(16, 16)">
            <circle cx="0" cy="0" r="14" fill="url(#glowBg)" />
            <path d="M0 -14 L12.124 -7 L12.124 7 L0 14 L-12.124 7 L-12.124 -7 Z" stroke="url(#logoGrad1)" strokeWidth="1" strokeOpacity="0.6" strokeDasharray="3 4" fill="none">
                <animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="20s" repeatCount="indefinite" />
            </path>
        </g>

        {/* Animated Bars */}
        <rect x="7" y="16" width="4" height="8" rx="2" fill="url(#logoGrad2)" filter="url(#glowShadow)">
            <animate attributeName="height" values="8;11;8" dur="3s" repeatCount="indefinite" />
            <animate attributeName="y" values="16;13;16" dur="3s" repeatCount="indefinite" />
        </rect>
        <rect x="14" y="11" width="4" height="13" rx="2" fill="url(#logoGrad3)" filter="url(#glowShadow)">
            <animate attributeName="height" values="13;17;13" dur="3s" begin="1s" repeatCount="indefinite" />
            <animate attributeName="y" values="11;7;11" dur="3s" begin="1s" repeatCount="indefinite" />
        </rect>
        <rect x="21" y="7" width="4" height="17" rx="2" fill="url(#logoGrad1)" filter="url(#glowShadow)">
            <animate attributeName="height" values="17;12;17" dur="3s" begin="2s" repeatCount="indefinite" />
            <animate attributeName="y" values="7;12;7" dur="3s" begin="2s" repeatCount="indefinite" />
        </rect>

        {/* Trend Line */}
        <path d="M5 19 L15 10 L22 14 L29 6" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.95" filter="url(#glowShadow)">
            <animate attributeName="d" values="M5 19 L15 10 L22 14 L29 6; M5 17 L15 12 L22 11 L29 6; M5 19 L15 10 L22 14 L29 6" dur="4s" repeatCount="indefinite" />
        </path>
    </svg>
);

export default Logo;
